import { createSelector } from 'reselect';
import { decodeCountryTaxType } from '../../../utils/encodeDecodeCTT';

export const slAccountsSelector = state => state.balanceSheetManagement.accountBalances.slAccounts;
export const slAccountsForSelectSelector = createSelector(
  slAccountsSelector,
  slAccounts => slAccounts.map(({ account, accountDescription }) => ({
    value: account,
    label: accountDescription,
  })));

export const selectedSlAccountsSelector = state => state.balanceSheetManagement.accountBalances.selectedSlAccounts;
export const slAccountsLoadingSelector = state => state.balanceSheetManagement.accountBalances.slAccountsLoading;

export const allAccountBalancesRawSelector = state => state.balanceSheetManagement.accountBalances.accountBalances;
export const accountBalancesSelector = createSelector(
  [
    allAccountBalancesRawSelector,
    selectedSlAccountsSelector,
  ],
  (accountBalances, selectedAccounts) =>
    accountBalances
      .filter(balance =>
        selectedAccounts.find(account => balance.slAccount === account.value)
      )
      .map(balance => ({
        ...balance,
        ...decodeCountryTaxType(balance.countryTaxType),
      }))

);

export const accountBalancesLoadingSelector = state =>
  state.balanceSheetManagement.accountBalances.accountBalancesLoading;
